import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";
import {useNavigate} from "react-router-dom";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantEvaluation from "./components/MantEvaluation.jsx";
import MantEvaluationStep02 from "./components/MantEvaluationStep02.jsx";
import {useZonaAgencia} from "../../context/ZonaAgenciaContext.jsx";
const MySwal = withReactContent(Swal);

const PageEvaluation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [destinosCredito, setDestinosCredito] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [formasPago, setFormasPago] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [tiposCredito, setTiposCredito] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [tiposProducto, setTiposProducto] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [categoriasEvaluacion, setCategoriasEvaluacion] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [tiposAnexo, setTiposAnexo] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [configuraciones, setConfiguraciones] = useState(CONFIGURACIONES.INIT.NULL);

    const [clasesPrestamo, setClasesPrestamo] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [clasePretamoCredito, setClasePretamoCredito] = useState(CONFIGURACIONES.INIT.STRING);
    
    const [clasePrestamoSelect, setClasePrestamoSelect] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [itemSelected, setItemSelected] = useState(CONFIGURACIONES.INIT.NULL);

    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [isStepEvaluation02, setIsStepEvaluation02] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [itemSaved, setItemSaved] = useState(CONFIGURACIONES.INIT.NULL);

    const [listSolicitudes, setListSolicitudes] = useState(CONFIGURACIONES.INIT.ARRAY);
    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();
    const { zona, agencia} = useZonaAgencia();

    const createEvaluation = async (form, path) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/${path}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), fnContinue, form);
    };

    const fnContinue = (data) => {
        setItemSaved(data);
        navigate(`${CONFIGURACIONES.SITES.EVALUATION_STEP_02}`);
    };

    const fnRedirectError = () => {
        navigate(`${CONFIGURACIONES.SITES.EVALUATION}`);
    };

    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDestinosCredito(rpta.data.destinosCredito);
                setFormasPago(rpta.data.formasPago);
                setTiposCredito(rpta.data.tiposCredito);
                setTiposProducto(rpta.data.productos);
                setClasesPrestamo(rpta.data.clasesPrestamo);
                setCategoriasEvaluacion(rpta.data.categoriasEvaluacion);
                setTiposAnexo(rpta.data.tiposAnexo);
                setConfiguraciones(rpta.data.configuraciones);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const searchData = () => {
        if (!zona || !agencia) { return; }

        showSpinnerLoader();
        let data = {
            body: {
                'agenciaId': agencia,
                'zonaId': zona,
                'usuarioRegistro': getUser().user,
            }
        }
        setListSolicitudes(CONFIGURACIONES.INIT.ARRAY);
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/evaluacion/buscar`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setListSolicitudes(rpta.data);
            }
        });
    }

    const fnRedirectApproval = () => {
        navigate(`${CONFIGURACIONES.SITES.EVALUATION}`);
        searchData();
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
        setItemSelected(CONFIGURACIONES.INIT.NULL);
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        setIsStepEvaluation02(lastSegment === 'step-02'?CONFIGURACIONES.INIT.STATUS_TRUE: CONFIGURACIONES.INIT.STATUS_FALSE);
        console.log('lastSegment', lastSegment);

        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])

    useEffect(() => {
        searchData()
    }, [zona, agencia]);

    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    {!isStepEvaluation02 && <MantEvaluation title={'Bandeja de Evaluación'} idEdit={idRef} MySwal={MySwal}
                                        icon={iconActive} user={getUser()} showSpinnerLoader={showSpinnerLoader}
                                        setIdRef={setIdRef} tiposCredito={tiposCredito} clasesPrestamo={clasesPrestamo}
                                        fnCrear={createEvaluation} destinosCredito={destinosCredito} setClasePretamoCredito={setClasePretamoCredito}
                                        showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)}
                                        showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)} clasePrestamoSelect={clasePrestamoSelect}
                                        zona={zona} agencia={agencia} list={listSolicitudes} setItemSelected={setItemSelected}  
                                        setClasePrestamoSelect={setClasePrestamoSelect} tiposProducto={tiposProducto}/>}

                                    {isStepEvaluation02 && <MantEvaluationStep02 title={'Evaluación'} idEdit={idRef} formasPago={formasPago} configuraciones={configuraciones}
                                            clasesPrestamo={clasePrestamoSelect} MySwal={MySwal} icon={iconActive} itemSelected={itemSaved} showSpinnerLoader={showSpinnerLoader}
                                            setIdRef={setIdRef} fnCrear={createEvaluation} clasePretamoCredito={clasePretamoCredito} tiposProducto={tiposProducto}
                                            showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} categoriasEvaluacion={categoriasEvaluacion} tiposAnexo={tiposAnexo}
                                            showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)} fnRedirectError={fnRedirectError} user={getUser()} fnRedirectApproval={fnRedirectApproval}/>}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PageEvaluation;